<template>
  <div class="page-content">
    <div class="left">
      <div class="item" v-for="item in list" :key="item.id">
        <span class="name">{{ item.name }}: </span>
        <span class="position">
          {{ item.first_position }}
          <br v-if="item.first_position" />{{ item.position }}
        </span>
      </div>
    </div>
    <div class="right">
      <div class="item" v-for="item in list" :key="item.id">
        <div class="item-img">
          <img :src="item.avatar | baseImg" class="img" />
        </div>
        <div class="tit">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLingdao } from "@/apis/zuzhijiagou";
export default {
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.getLingdao();
  },
  methods: {
    async getLingdao() {
      const { data } = await getLingdao();
      this.list = data || [];
    },
  },
};
</script>

<style lang="scss" scoped>
.page-content {
  display: flex;
  .left {
    margin-right: 20px;
    .item {
      width: 294px;
      height: 62px;
      line-height: 62px;
      background: rgba(245, 245, 245, 0.39);
      margin-bottom: 1px;
      padding-left: 20px;
      display: flex;
      .name {
        font-size: 16px;
        font-size: var(--font-size-16);
        font-weight: bold;
        line-height: 22px;
        color: #303133;
        width: 4em;
      }
      .position {
        font-size: 16px;
        font-size: var(--font-size-16);
        font-weight: 500;
        line-height: 22px;
        color: #303133;
        flex: 1;
      }
    }
  }
  .right {
    display: flex;
    flex-wrap: wrap;
    .item {
      margin-right: 20px;
      margin-bottom: 20px;
      text-align: center;
      .item-img {
        position: relative;
        .img {
          height: 220px;
          width: 150px;
          object-fit: cover;
        }
      }
      .tit {
        font-size: 16px;
        font-size: var(--font-size-16);
        font-weight: 500;
        line-height: 22px;
        margin-top: 20px;
        color: #303133;
      }
    }
  }
}
</style>
